import { FC, ReactNode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type PortalProps = {
  children: ReactNode;
};

export const Portal: FC<PortalProps> = (props) => {
  const { children } = props;
  const [container] = useState<HTMLDivElement>(() =>
    document.createElement('div'),
  );

  useEffect(() => {
    if (document.fullscreenElement) {
      document.fullscreenElement.appendChild(container);
    } else {
      document.body.appendChild(container);
    }

    return () => {
      if (document.fullscreenElement) {
        document.fullscreenElement.removeChild(container);
      } else {
        document.body.removeChild(container);
      }
    };
  }, [container]);

  return ReactDOM.createPortal(children, container);
};
